import { useLayoutEffect, useRef, type ComponentProps } from 'react';
import { cn } from '@/lib/utils';

// <table> que no celular e no tablet vira uma lista de cartões: cada linha é um
// cartão, a primeira célula é o título e as demais aparecem como
// "rótulo: valor". O rótulo vem do <th> da mesma coluna e é copiado para o
// data-label de cada célula (inclusive quando as linhas mudam), então a tabela
// não precisa repetir o nome da coluna em cada <td>. O visual está em
// globals.css (.tabela-cartoes): cartões abaixo de 1024px, dois por linha no
// tablet. A partir de 1024px é uma tabela comum.
export function TabelaCartoes({ className, ...props }: ComponentProps<'table'>) {
  const ref = useRef<HTMLTableElement>(null);

  useLayoutEffect(() => {
    const tabela = ref.current;
    if (!tabela) return;

    const rotular = () => {
      const titulos = Array.from(tabela.querySelectorAll('thead th')).map(
        (th) => th.textContent?.trim() ?? ''
      );
      tabela.querySelectorAll('tbody tr').forEach((tr) => {
        let coluna = 0;
        Array.from(tr.children).forEach((celula) => {
          const span = (celula as HTMLTableCellElement).colSpan || 1;
          const rotulo = span > 1 ? '' : (titulos[coluna] ?? '');
          if (celula.getAttribute('data-label') !== rotulo) {
            celula.setAttribute('data-label', rotulo);
          }
          coluna += span;
        });
      });
    };

    rotular();
    const observador = new MutationObserver(rotular);
    observador.observe(tabela, { childList: true, subtree: true, characterData: true });
    return () => observador.disconnect();
  }, []);

  return <table ref={ref} className={cn('tabela-cartoes', className)} {...props} />;
}
